"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var styles = function styles(theme) {
  return {
    root: {
      boxShadow: 'none'
    },
    flexGrow: {
      flexGrow: 1
    },
    logo: _defineProperty({
      display: 'flex',
      alignItems: 'center',
      fontSize: 0,
      width: '90px',
      cursor: 'pointer'
    }, theme.breakpoints.up('sm'), {
      width: '130px'
    })
  };
};

var _default = styles;
exports.default = _default;